/* eslint-disable react/no-array-index-key */
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

export const EditFTF = ({ data }: any) => (
  <Checkbox checked={data.facetofacevisit} disabled size="small" />
);
